export const HOME_DASHBOARD_IMAGE_PATH = '/home-dashboard.jpeg';
export const HOME_DASHBOARD_IMAGE_LARGE_PATH = '/home-dashboard-1200.jpeg';
export const HOME_DASHBOARD_IMAGE_SRCSET = `${HOME_DASHBOARD_IMAGE_PATH} 840w, ${HOME_DASHBOARD_IMAGE_LARGE_PATH} 1200w`;
export const HOME_DASHBOARD_IMAGE_SIZES = '(min-width: 1200px) 420px, 100vw';
